define('Cart.AddToCart.Button.View.Extension', [
  'Product.Model',
  'underscore',
  'jQuery',
  'Utils',
  'Cart.AddToCart.Button.View'
], function (
  ProductModel,
  _,
  jQuery,
  Utils,
  CartAddToCartButtonView
) {
  'use strict';
  _.extend(ProductModel.prototype, {
    areAttributesValid: function areAttributesValid(attributes, validators) {
      var current_validation = _.extend({}, this.validation);

      _.extend(this.validation, validators || {});

      var result = this.isValid(attributes);
      this.validation = current_validation;
      return true;
    }
  });

  _.extend(CartAddToCartButtonView.prototype, {
     getContext: _.wrap(CartAddToCartButtonView.prototype.getContext, function (fn) {
      var context = fn.apply(this, _.toArray(arguments).slice(1));
      var isPLP = this.attributes && this.attributes['data-root-component-id'] === "Facets.Browse.View";
      if (!isPLP) {
        return context;
      }
      var item = this.model.get('item');
      var isConfigurable = item && item.get('custitem_option1description') ? true : false;
      var url = item && item.get('urlcomponent')
      context.isConfigurable = isConfigurable
      context.url = url
      return context;
    })
  });
});
